import SectionLayout from './SectionLayout';
import { useSelector } from 'react-redux';
import ServiceSwitcherMobile from './ServiceSwitcherMobile';
import styles from '../headers.module.css';

export default function PendingHeaderFilter() {
	const user = useSelector((state) => state.user.user);
	const child = useSelector((state) => state.lifebooks.child);

	const options = [
		{ label: 'All', path: 'pending' },
		{ label: 'Timeline', path: 'pendingTL' },
		{ label: 'Services', path: 'pendingNsp' },
	];

	const showFilter = user.role === 'contributor' && child ? false : true;

	return (
		<SectionLayout
			label={showFilter ? `Filter:` : null}
			className={styles.sectionLayoutContainer}>
			{showFilter ? <ServiceSwitcherMobile options={options} /> : null}
		</SectionLayout>
	);
}
